import React, { useCallback, useContext } from 'react';

import { TopTerritoriesItem } from './TopTerritories';
import { EntityContext } from 'context/entityContext';
import { ICities, IEntity } from './types';

/**
 * TopCities displays a single TopCities list item in the
 * TopTerritoriesItem component.
 * @param {object} props React props
 * @param {object} props.item TopCity item
 * @param {object} props.entity Entity object like { id, type }
 * @param {number} props.rank This cities' rank
 */
interface IProps {
  item: ICities;
  entity: IEntity;
  rank: number;
}

export const TopCities: React.FC<IProps> = (props) => {
  const { item, entity, rank } = props;

  const ctx = useContext(EntityContext);
  const { compareMode, dataColors, countryIds, entityIds } = ctx;

  const getColor = useCallback(() => {
    if (compareMode === 'country') {
      const idx = countryIds?.findIndex((el) => el === (item.countryId as any));
      return dataColors[Number(idx)];
    }
    if (compareMode === 'entity') {
      const idx = entityIds.findIndex((el) => el === entity.id);
      return dataColors[idx];
    }
  }, [
    compareMode,
    dataColors,
    countryIds,
    item.countryId,
    entity.id,
    entityIds,
  ]);

  return (
    <TopTerritoriesItem data-rank={rank} dataColor={getColor()}>
      {item.cityName}
    </TopTerritoriesItem>
  );
};
